import { render, staticRenderFns } from "./MapeiLogo.vue?vue&type=template&id=44fcad76&scoped=true&"
var script = {}
import style0 from "./MapeiLogo.vue?vue&type=style&index=0&id=44fcad76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcad76",
  null
  
)

export default component.exports